import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Upload, Icon, Spin } from 'antd';
import cn from 'classnames';
import FormItem from '../../ui/FormItem/FormItem';
import { actions, selectors, stateKeys } from '../../../model';
import { xlsxMIMEType } from '../../../lib/file';
import { uploadingFieldNames } from '../../../config/uploadingStep';
import styles from './UploadFile.module.scss';

const { Dragger } = Upload;

const { selectUploadingStepValue, selectUploadingStepError, selectStateValue } =
  selectors;
const { fileChangeAsyncAction } = actions;

const uploadName = uploadingFieldNames.file;

const valueSelector = (state) => selectUploadingStepValue(state, uploadName);
const errorSelector = (state) => selectUploadingStepError(state, uploadName);
const isFileUploadingSelector = (state) =>
  selectStateValue(state, stateKeys.isFileUploading);

const UploadList = ({ items }) => {
  return (
    <ul className={styles.uploadList}>
      {items.map((file) => (
        <li
          key={file.uid}
          className={styles.uploadItem}
        >
          <Icon type="paper-clip" />
          {file.name}
        </li>
      ))}
    </ul>
  );
};

const UploadContent = () => {
  return (
    <>
      <div className={styles.contentHeader}>
        <Icon
          type="file-excel"
          className={styles.contentIcon}
        />

        <p className={styles.contentTitle}>
          Кликните или перетащите файл в эту область
        </p>
      </div>

      <p className="ant-upload-hint">Поддерживаемые форматы: xlsx</p>
    </>
  );
};

const beforeUpload = () => false;

const UploadWrapper = ({ children }) => {
  const value = useSelector(valueSelector);
  const errors = useSelector(errorSelector);
  const isFileUploadinig = useSelector(isFileUploadingSelector);

  const dispatch = useDispatch();

  const handleChange = (data) => dispatch(fileChangeAsyncAction(data));

  return (
    <Spin spinning={isFileUploadinig}>
      <FormItem
        required
        label="Файл"
        className={styles.root}
        errors={errors}
      >
        <Dragger
          className={cn(styles.dragger, {
            [styles.draggerError]: Boolean(errors?.length),
          })}
          beforeUpload={beforeUpload}
          accept={xlsxMIMEType}
          fileList={value}
          onChange={handleChange}
          disabled={isFileUploadinig}
          showUploadList={false}
        >
          {children}
        </Dragger>
        {Boolean(value?.length) && <UploadList items={value} />}
      </FormItem>
    </Spin>
  );
};

const UploadFile = () => (
  <UploadWrapper>
    <UploadContent />
  </UploadWrapper>
);

export default UploadFile;
